/**
 * FT (2026-06-12): Click-Handler für den Drawer-Upsell-Slot (ft-drawer-upsells.liquid).
 *
 * Bewusst als eigenständiges Asset statt Inline-Script im Snippet:
 * Das Snippet rendert nur bei nicht-leerem Warenkorb, und Horizons morph()
 * führt neu eingefügte Inline-Scripts nicht aus (re-aktiviert nur
 * `.shopify-app-block script[src]`, siehe assets/morph.js). Ein Inline-Handler
 * wäre nach dem Flow „leerer Warenkorb → Add-to-Cart" tot gewesen.
 * Dieses Asset wird in header-actions.liquid neben cart-drawer.js geladen
 * (immer, wenn der Drawer aktiv ist) und arbeitet per Event-Delegation —
 * überlebt damit jeden Morph.
 */

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-ft-drawer-upsell-add]');
  if (!button || button.disabled) return;
  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.disabled = true;
  button.textContent = '…';

  try {
    const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: { _quelle: 'drawer-upsell' } }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || 'Konnte nicht hinzugefügt werden');
    }

    const cart = await fetch('/cart.js').then((r) => r.json());
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'ft-drawer-upsells',
          data: { source: 'ft-drawer-upsells', itemCount: 1, variantId, sections: data.sections },
        },
      })
    );
    // Kein Button-Reset nötig: der Drawer morpht und rendert den Slot neu.
  } catch (e) {
    button.textContent = 'Fehler';
    setTimeout(() => {
      button.textContent = 'Mitnehmen';
      button.disabled = false;
    }, 2000);
  }
});
